import { FormController } from '../classes/form-controller';
const axios = require('axios');

export default class extends FormController {
	static targets = [
		'container',
		'form',
		'field',
		'input',
		'errorNotice',
		'successNotice',

		'step1',
		'step2',
		'step3',
		'step3_1',
		'step3_2',
		'step4',
		'step4message',
		'step5',
		'step6',

		'step1SubmitButton',
		'step2SubmitButton',
		'step3SubmitButton',
		'step3_1SubmitButton',
		'step3_2SubmitButton',
		'step4SubmitButton',
		'step5SubmitButton',
	];

	connect() {
		// Call connect from FormController
		super.connect();
	}

	/**
	 * Submit step 1 - Accept terms.
	 *
	 * @param {Event} e
	 */
	submitStep1(e) {
		e.preventDefault();

		const formData = new FormData(this.formTarget);
		formData.append('action', 'external_vacancy_application_form_submit_step_1');

		this.step1Target.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.step1Target.removeAttribute('data-group-loading');
				}

				if (response.data.status == 'success') {

					if (response.data.message == 'MaintenanceModeOn') {
						window.location = window.location.href;
						this.step1Target.removeAttribute('data-group-loading');
					} else {
						this.step1Target.classList.add('hidden');
						this.step2Target.classList.remove('hidden');
	
						this.containerTarget.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						});
	
						this.setBeforeUnloadAlert();
	
						this.step1SubmitButtonTarget.setAttribute('type', 'button');
						this.step2SubmitButtonTarget.setAttribute('type', 'submit');
					}
				}
			})
			.catch((error) => {
				console.log(error);
				this.step1Target.removeAttribute('data-group-loading');
			});
	}

	/**
	 * Submit step 2 - Enter email.
	 *
	 * @param {Event} e
	 */
	submitStep2(e) {
		e.preventDefault();

		const formData = new FormData(this.formTarget);
		formData.append('action', 'external_vacancy_application_form_submit_step_2');

		this.step2Target.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.step2Target.removeAttribute('data-group-loading');
				}

				if (response.data.status == 'success') {

					if (response.data.message == 'MaintenanceModeOn') {
						window.location = window.location.href;
						this.step2Target.removeAttribute('data-group-loading');
					} else {
						this.step2Target.classList.add('hidden');

						// If user exists show password step
						if (response.data.userExists == true) {
							this.step3Target.classList.remove('hidden');

							// If user does not exist skip this step
						} else {
							this.step4Target.classList.remove('hidden');
						}

						this.containerTarget.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						});

						this.step2SubmitButtonTarget.setAttribute('type', 'button');
						this.step3SubmitButtonTarget.setAttribute('type', 'submit');
					}
				}
			})
			.catch((error) => {
				console.log(error);
				this.step2Target.removeAttribute('data-group-loading');
			});
	}

	/**
	 * Submit step 3 - Enter password.
	 *
	 * @param {Event} e
	 */
	submitStep3(e) {
		e.preventDefault();

		const formData = new FormData(this.formTarget);
		formData.append('action', 'external_vacancy_application_form_submit_step_3');

		this.step3Target.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.step3Target.removeAttribute('data-group-loading');
				}

				if (response.data.status == 'success') {

					if (response.data.message == 'MaintenanceModeOn') {
						window.location = window.location.href;
						this.step3Target.removeAttribute('data-group-loading');
					} else {
						this.step3Target.classList.add('hidden');
						this.step4Target.classList.remove('hidden');

						this.containerTarget.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						});

						this.step3SubmitButtonTarget.setAttribute('type', 'button');
						this.step4SubmitButtonTarget.setAttribute('type', 'submit');
					}
				}
			})
			.catch((error) => {
				console.log(error);
				this.step3Target.removeAttribute('data-group-loading');
			});
	}

	/**
	 * Submit step 3.1 - Request password reset.
	 *
	 * @param {Event} e
	 */
	submitStep3_1(e) {
		e.preventDefault();

		const formData = new FormData(this.formTarget);
		formData.append('action', 'external_vacancy_application_form_submit_step_3_1');

		this.step3_1SubmitButtonTarget.classList.add('btn-loading');
		this.step3_1Target.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.step3_1Target.removeAttribute('data-group-loading');
					this.step3_1SubmitButtonTarget.classList.remove('btn-loading');
				}

				if (response.data.status == 'success') {
					if (response.data.message == 'MaintenanceModeOn') {
						window.location = window.location.href;
						this.step3_1Target.removeAttribute('data-group-loading');
						this.step3_1SubmitButtonTarget.classList.remove('btn-loading');
					} else {
						this.step3Target.classList.add('hidden');
						this.step3_2Target.classList.remove('hidden');

						this.containerTarget.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						});

						this.step3SubmitButtonTarget.setAttribute('type', 'button');
						this.step3_2SubmitButtonTarget.setAttribute('type', 'submit');
					}
				}
			})
			.catch((error) => {
				console.log(error);
				this.step3_1Target.removeAttribute('data-group-loading');
				this.step3_1SubmitButtonTarget.classList.remove('btn-loading');
			});
	}

	/**
	 * Submit step 3.2 - Reset password.
	 *
	 * @param {Event} e
	 */
	submitStep3_2(e) {
		e.preventDefault();

		const formData = new FormData(this.formTarget);
		formData.append('action', 'external_vacancy_application_form_submit_step_3_2');

		this.step3_2Target.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.step3_2Target.removeAttribute('data-group-loading');
				}

				if (response.data.status == 'success') {
					if (response.data.message == 'MaintenanceModeOn') {
						window.location = window.location.href;
						this.step3_2Target.removeAttribute('data-group-loading');
					} else {
						this.step3_2Target.classList.add('hidden');
						this.step4Target.classList.remove('hidden');

						this.containerTarget.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						});

						this.step3_2SubmitButtonTarget.setAttribute('type', 'button');
						this.step4SubmitButtonTarget.setAttribute('type', 'submit');
					}
				}

				if (response.data.notice) {
					this.successNoticeTarget.innerHTML = response.data.notice;
				}
			})
			.catch((error) => {
				console.log(error);
				this.step3_2Target.removeAttribute('data-group-loading');
			});
	}

	/**
	 * Submit step 4 - Upload resume.
	 *
	 * @param {Event} e
	 */
	submitStep4(e) {
		e.preventDefault();

		const formData = new FormData(this.formTarget);
		formData.append('action', 'external_vacancy_application_form_submit_step_4');

		this.step4Target.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			})
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.step4Target.removeAttribute('data-group-loading');
				}

				if (response.data.status == 'success') {
					if (response.data.message == 'MaintenanceModeOn') {
						window.location = window.location.href;
						this.step4Target.removeAttribute('data-group-loading');
					} else {
						// Hide success notice from changing password step
						this.successNoticeTarget.innerHTML = '';

						this.prefillProfileFields(response.data.extractedFields);

						this.step4Target.classList.add('hidden');
						this.step5Target.classList.remove('hidden');

						this.containerTarget.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						});

						this.step4SubmitButtonTarget.setAttribute('type', 'button');
						this.step5SubmitButtonTarget.setAttribute('type', 'submit');
					}
				}
			})
			.catch((error) => {
				console.log(error);
				this.step4messageTarget.classList.remove('hidden');
				this.step4messageTarget.classList.add('block');
				this.step4Target.removeAttribute('data-group-loading');
			});
	}

	/**
	 * Submit step 4 - Upload resume.
	 *
	 * @param {Event} e
	 */
	// Stuff for testing new way of uploading file 
	// https://linear.app/super-interactive/issue/LEE-279/cv-stap-sollicitatieproces-geeft-foutmelding-in-console#comment-1d25bf1b
	// submitStep4(e) {
	// 	e.preventDefault();

	// 	const formData = new FormData(this.formTarget);
	// 	// formData.append('action', 'external_vacancy_application_form_submit_step_4');
	// 	formData.append('nonce', supersage.external_vacancy_nonce);
	// 	// First step is uploading the file to temp folder with api
	// 	const uploadEndpoint = '/wp-json/vacancy/v1/upload';

	// 	this.step4Target.setAttribute('data-group-loading', 'true');

	// 	axios
	// 		.post(uploadEndpoint, formData, {
	// 			headers: {
	// 				'X-WP-Nonce': supersage.restNonce,
	// 				'Content-Type': 'multipart/form-data',
	// 			},
	// 		})
	// 		.then((response) => {
	// 			if (response.data.status == 'error') {
	// 				this.displayErrors(response.data.errors);
	// 				this.step4Target.removeAttribute('data-group-loading');
	// 				return;
	// 			}

	// 			const filename = response.data.temp_file; 
				
	// 			const formDataStepNextAjax = new FormData();
	// 			formDataStepNextAjax.append('action', 'external_vacancy_application_form_submit_step_4');
	// 			formDataStepNextAjax.append('nonce', supersage.external_vacancy_nonce);
	// 			formDataStepNextAjax.append('filename', filename);
				
	// 			return axios.post(supersage.ajaxURL, formDataStepNextAjax);
	// 		})
	// 		.then((response) => {
	// 			if (!response || response.data.status === 'error') {
	// 				this.displayErrors(response.data.errors);
	// 				this.step4Target.removeAttribute('data-group-loading');
	// 				return;
	// 			}
		
	// 			this.prefillProfileFields(response.data.extractedFields);
		
	// 			this.step4Target.classList.add('hidden');
	// 			this.step5Target.classList.remove('hidden');
		
	// 			this.containerTarget.scrollIntoView({
	// 				behavior: 'smooth',
	// 				block: 'start',
	// 			});
		
	// 			this.step4SubmitButtonTarget.setAttribute('type', 'button');
	// 			this.step5SubmitButtonTarget.setAttribute('type', 'submit');
	// 		})
	// 		.catch((error) => {
	// 			console.log(error);
	// 			this.step4Target.removeAttribute('data-group-loading');
	// 		});
	// }

	/**
	 * Submit step 5 - Profile.
	 *
	 * @param {Event} e
	 */
	submitStep5(e) {
		e.preventDefault();

		const formData = new FormData(this.formTarget);
		formData.append('action', 'external_vacancy_application_form_submit_step_5');

		this.step5Target.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			})
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.step5Target.removeAttribute('data-group-loading');

					// Scroll error in view
					const firstErrorField = this.containerTarget.querySelector('[data-group-error="true"]');

					if (this.errorNoticeTarget.hasChildNodes()) {
						this.containerTarget.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						});
					} else if (firstErrorField) {
						firstErrorField.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						});
					} else {
						this.containerTarget.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						});
					}
				}

				if (response.data.status == 'success') {
					if (response.data.message == 'MaintenanceModeOn') {
						window.location = window.location.href;
						this.step5Target.removeAttribute('data-group-loading');
					} else {
						// Hide error notice from step 5.
						this.errorNoticeTarget.innerHTML = '';

						this.step5Target.classList.add('hidden');
						this.step6Target.classList.remove('hidden');

						this.containerTarget.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						});

						this.step5SubmitButtonTarget.setAttribute('type', 'button');

						this.removeBeforeUnloadAlert();
					}
				}
			})
			.catch((error) => {
				console.log(error);
				this.step5Target.removeAttribute('data-group-loading');
			});
	}

	/**
	 * Prefill profile fields from extracted resume data.
	 *
	 * @param {Object} extractedFields
	 */
	prefillProfileFields(extractedFields) {
		this.inputTargets.forEach(function (inputField) {
			if (inputField.name == 'gender') {
				inputField.value = extractedFields[inputField.name].toLowerCase();
			} else if (extractedFields[inputField.name]) {
				inputField.value = extractedFields[inputField.name];
			}
		});
	}

	/**
	 * Set before unload alert.
	 */
	setBeforeUnloadAlert() {
		window.onbeforeunload = function () {
			return 'Het formulier is nog niet verzonden. Weet je zeker dat je de pagina wilt verlaten?';
		};
	}

	/**
	 * Remove before unload alert.
	 */
	removeBeforeUnloadAlert() {
		window.onbeforeunload = null;
	}
}
